<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <v-overlay :value="dataReady">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>

          <v-col cols="12">
              <v-sheet tile height="54" class="d-flex">
                <v-select
                  v-model="Department"
                  :items="DepartmentItem"
                  dense
                  outlined
                  hide-details
                  label="แผนก"
                  class="ma-2"
                ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon   color="#871B12" size="30" @click="getDataEmpSearch()"
                >mdi-calendar-search</v-icon
              >
               <v-icon color="#871B12" size="30" @click="clear()"
                >mdi-refresh</v-icon
              >
            </v-sheet>
          </v-col>
        <v-divider></v-divider>

        <!-- ตารางวันทำงาน -->

        <v-row>
          <v-col cols="6" v-for="(items, index) in dataItem" :key="index">
            <v-card class="pa-2" outline title>
              <v-card-title class="justify-center"
                >{{ items.empCode }}: {{ items.empFull_NameTH }}</v-card-title
              >
                <v-sheet height="500">
                  <v-calendar
                    :start="startdate"
                    ref='calendar'
                    :events="items.events"
                  >
                  </v-calendar>
                </v-sheet>
            </v-card>
          </v-col>
        </v-row>
        <!-- </v-row> -->
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import moment from 'moment' // แปลง date
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile
  },
  data () {
    return {
      rollHR: false,
      PK: '',
      path: '/shift_import/', // Path Model
      // Menu Config
      value: '',
      searchAll: '',
      monthImport: '',
      month: '',
      year: '',
      startdate: this.getDateTh(),
      session: this.$session.getAll(),
      shift: [],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'กะพนักงานสาขา',
          disabled: true,
          href: '/Shift/ImportTimeShiftGA'
        }
      ],
      form: {
        qeury: ''
      },
      formDelete: {
        QueryEmp: '',
        shiftYear: '',
        shiftMonth: ''
      },
      columns: [{ text: 'ชื่อพนักงาน', value: 'empFull_NameTH' }],
      dataItem: [],
      dataShiftItem: [],
      dataMasterShiftItem: [],
      selected: [2],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      dialogTemplate: false,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      masDepartmentCode: '',
      dialogExport: false,

      dialogImport: false,
      columnsImport: [
        { text: 'empCode', value: 'empCode' },
        { text: 'ปี', value: 'shiftYear' },
        { text: 'เดือน', value: 'shiftMonth' },
        { text: 'วันที่', value: 'shiftDay' },
        { text: 'ประเภทกะ', value: 'shiftCode' }
      ],
      dataItemImportChecKHide: true,
      dataItemImport: [],
      events: [],
      masks: {
        weekdays: 'WWW'
      },
      attributes: [],
      // End Export Config
      Datas: {
        // We will make a Workbook contains 2 Worksheets
        shiftExport: []
      },
      checkShiftCountErrorImport: 0,
      CountTotal: 0,
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: this.$session.getAll().data.masBranchName, // บริษัท
      Department: '', // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      dataReady: false
    }
  },
  async mounted () {
    await this.getGetToken()
    await this.getDataMasterShift()
    await this.getDataDepartment()
    // await this.getDataCalendar()
    let Month = this.getMonthTh()
    this.month = Month
    this.monthImport = Month
    // let date = new Date()
    this.year = moment().format('YYYY')
  },
  methods: {
    async getDataMasterShift () {
      this.dataMasterShiftItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/master_shift_type/get',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log(response)
          this.dataMasterShiftItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async clear () {
      this.Department = ''
      let Month = this.getMonthTh()
      this.month = Month
      this.monthImport = Month
      // let date = new Date()
      this.year = moment().format('YYYY')
      await this.getDataEmpSearch()
    },
    // Template
    exportToExcel () {
      var tem = []
      console.log(this.dataItem)

      this.dataItem.forEach((element) => {
        var s = {}
        console.log('emp', element)
        s.empCode = element.empCode
        s.empFull_NameTH = element.empFull_NameTH
        for (let i = 1; i < 31; i++) {
          s['D' + i] = 'S'
        }
        tem.push(s)
      })
      var animalWS = XLSX.utils.json_to_sheet(tem)
      // // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, animalWS, 'workship') // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, 'pokemons')

      // export Excel file
      XLSX.writeFile(wb, 'shift_template.xls') // name of the file is 'book.xlsx'
    },
    // Export Data
    exportShift () {
      var code = []
      var h = {}
      this.dataShiftItem.forEach((elmShift) => {
        h.empCode = elmShift.empCode
        code.push(h.empCode)
      })
      let uniqueChars = [...new Set(code)]

      var shift = []
      uniqueChars.forEach((elmCode) => {
        var s = {}
        console.log()
        this.dataShiftItem = this.dataShiftItem.slice().sort((a, b) => a.shiftDay - b.shiftDay)
        this.dataShiftItem.forEach((elmShift) => {
          if (elmCode === elmShift.empCode) {
            s.empCode = elmShift.empCode
            s.empFull_NameTH = elmShift.empFull_NameTH
            s['D' + elmShift.shiftDay] = elmShift.shiftCode
          }
        })
        shift.push(s)
      })

      // var shift = uniqueChars.map((elmCode) => {
      //   var s = {}
      //   console.log()
      //   this.dataShiftItem = this.dataShiftItem.slice().sort((a, b) => a.shiftDay - b.shiftDay)
      //   this.dataShiftItem.forEach((elmShift) => {
      //     if (elmCode === elmShift.empCode) {
      //       s.empCode = elmShift.empCode
      //       s.empFull_NameTH = elmShift.empFull_NameTH
      //       s['D' + elmShift.shiftDay] = elmShift.shiftCode
      //     }
      //   })
      //   return s
      //   // return JSON.stringify(s)
      // })

      // shift.forEach(element => {
      //   console.log('day push :', JSON.parse(element))
      // })

      var shiftExport = XLSX.utils.json_to_sheet(shift)

      var wb = XLSX.utils.book_new() // make Workbook of Excel

      XLSX.utils.book_append_sheet(wb, shiftExport, 'shiftExport')

      XLSX.writeFile(wb, 'shift_export.xls')
    },
    async getDataEmpSearch () {
      // let data = JSON.parse(localStorage.getItem('data'))

      this.dataReady = true
      this.dataItem = []

      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/employee/get?masBranchName=' +
            this.$session.getAll().data.masBranchName + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataItem = response.data
          this.searchShiftData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = false
        })
    },
    async searchShiftData () {
      this.dataReady = true
      var Department = (this.Department === '' ? '' : '&masDepartmentName=' + this.Department)
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "get?masBranchName=" + this.$session.getAll().data.masBranchName + Department + '&shiftMonth=' + this.getMonthThToINT(this.month) + '&shiftYear=' + this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = false
          this.dataItem.forEach((element) => {
            // เพิ่มตัวแปร events
            element.events = []

            // กะทำงาน
            response.data.forEach(elmShift => {
              // เชคคนท่ี่ มีอยู่ใน กะ
              if (element.empCode === elmShift.empCode) {
                var dateFormat = elmShift.shiftYear + '-' + elmShift.shiftMonth + '-' + elmShift.shiftDay
                var date = moment(String(dateFormat)).format('YYYY-MM-DD')
                this.startdate = date
                element.events.push({
                  name: elmShift.masShiftTypeName,
                  start: date,
                  color: elmShift.masShiftTypeColor
                })
              }
            })
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    async getDataCalendar () {
      let data = JSON.parse(localStorage.getItem('data'))
      this.dataShiftItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/' +
            'get?masBranchName=' +
            data.masBranchName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataShiftItem = response.data
          // dataItem ข้อมูลคน
          this.dataItem.forEach((element) => {
            // เพิ่มตัวแปร events
            element.events = []

            // กะทำงาน
            response.data.forEach(elmShift => {
              // เชคคนท่ี่ มีอยู่ใน กะ
              if (element.empCode === elmShift.empCode) {
                var dateFormat = elmShift.shiftYear + '-' + elmShift.shiftMonth + '-' + elmShift.shiftDay
                var date = moment(String(dateFormat)).format('YYYY-MM-DD')
                element.events.push({
                  name: elmShift.masShiftTypeName,
                  start: date,
                  color: elmShift.masShiftTypeColor
                })
              }
            })
            // console.log(element)
          })
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // * Option Import Excel
    // * ตั้งค่าจาก Data
    importData (event) {
      var checkShiftCountErrorImport = 0
      var CountTotal = 0
      var input = event.target
      var reader = new FileReader()
      this.shift = []
      this.shiftEmployee = []
      // var checkEmpOtherDep = false
      reader.onload = () => {
        var fileData = reader.result
        var wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          var rowObj = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])

          // Data ที่ได้จาก Excel
          this.dataItemImport = rowObj

          for (var i = 0; i < rowObj.length; i++) {
            var d = rowObj[i]
            var keyCount = Object.keys(d).length
            var countLoop = keyCount - 1

            for (var index = 1; index < countLoop; index++) {
              // หาตำแหน่งของวัน
              CountTotal += 1
              var element = d['D' + index]
              var s = {}
              s.empCode = d['empCode'].trim()
              s.shiftDay = index
              s.shiftMonth = this.getMonthThToINT(this.monthImport)
              s.shiftYear = this.year
              s.shiftCode = element.toUpperCase()

              console.log(s.empCode)
              // console.log(s.shiftCode)

              this.dataMasterShiftItem.filter(function (elem) {
                if (elem.masShiftTypeCode === element) {
                  checkShiftCountErrorImport += 1
                  return elem.masShiftTypeCode
                }
              })

              s.shiftType = 'WORK'
              this.shift.push(s)
              this.shiftEmployee.push(s.empCode)
            }
          }
        })
        if (CountTotal !== checkShiftCountErrorImport) {
          this.$swal('นำเข้าผิดพลาด', 'รหัสกะของท่านไม่ตรงกับฐานข้อมูล', 'error').then(async (result) => {
            this.$refs.inputFile.value = null
          })
            .catch((error) => {
              console.log(error)
              this.$refs.inputFile.value = null
            })
        } else {
          if (this.dataItemImport.length === 0) {
            alert('โปรดใส่ไฟล์ให้ถูกต้อง')
            this.$refs.inputFile.value = null
          } else {
            this.dataItemImportChecKHide = false
          }
        }
      }

      reader.readAsBinaryString(input.files[0])
    },
    // Step 0 Confirm Approve
    importDataApprove (action) {
      console.log('importDataApprove ===  [/]')
      this.$swal({
        title: 'ท่านต้องการ นำเข้าข้อมูลจากไฟล์นี้ ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          this.importDataAdd(this.shift)
        })
        .catch((error) => {
          console.log('error function importDataApprove : ', error)
          this.$refs.inputFile.value = null

          this.dataReady = false
        })
    },
    // Step 1 Delete Old Shift
    async importDataAdd (dt) {
      console.log('importDataAdd ===  [/]')
      console.log(' importDataAdd', dt)
      console.log(' shiftEmployee', this.shiftEmployee)
      var emp = new Set(this.shiftEmployee)
      var arrayEmp = [...emp]
      console.log([...emp])
      var strA = '('
      var strB = ''
      var strC = ''
      var str = ''
      await arrayEmp.forEach(async (elm) => {
        strB +=
            "'" +
            elm +
            "',"
      })
      console.log('before', strB)
      console.log('strB.length', strB.length)
      strB.substr(0, strB.length - 1)
      console.log('after', strB)
      strC = ')'

      str = strA + strB.substr(0, strB.length - 1) + strC
      var QueryEmp = str
      console.log(QueryEmp)

      this.formDelete.QueryEmp = QueryEmp
      this.formDelete.shiftYear = this.year

      // console.log(this.formDelete)
      this.formDelete.shiftMonth = this.getMonthThToINT(this.monthImport)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_import/deleteShift",
          this.formDelete,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.CheckBeforeAddRow(dt)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error ', error)
        })
    },
    // Step 2 Setup Format Insert
    async CheckBeforeAddRow (dt) {
      let data = JSON.parse(localStorage.getItem('data'))

      // eslint-disable-next-line one-var
      var i, j, temporary, chunk = 100

      var shiftImportRunnigCode = ''
      var datetime = this.getDateTimeTh()
      await this.getRunningCodeGlobal(
        this.DNS_IP,
        this.Department + '_'
      ).then(async (response) => {
        shiftImportRunnigCode = response

        for (i = 0, j = dt.length; i < j; i += chunk) {
          temporary = dt.slice(i, i + chunk)
          var str = ''
          await temporary.forEach(async (Object) => {
            str +=
            "('" +
            Object.empCode +
            "'," +
            Object.shiftDay +
            ',' +
            Object.shiftMonth +
            ',' +
            Object.shiftYear +
            ",'" +
            Object.shiftCode +
            "','" +
            this.$session.getAll().data.masDepartmentCode +
            "','" +
            this.$session.getAll().data.masBranchName +
            "','" +
            shiftImportRunnigCode +
            "','" +
            Object.shiftType +
            "','" +
            datetime +
            "','" +
            datetime +
            "','" +
            data.userName +
            "','" +
            data.userName +
            "'),"
          })
          var Query = str.substr(0, str.length - 1)
          // console.log(Query)
          this.DataAdd(Query)
        }
      })
    },
    // Step 3 Insert Row
    async DataAdd (dt) {
      this.form.qeury = dt
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/shift_import/addRow",
          this.form,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.$refs.inputFile.value = null

          this.dialogImport = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function addDataGlobal : ', error)
        })
    },
    clearFile () {
      this.dataItemImportChecKHide = true
      this.$refs.inputFile.value = null
    },
    // แผนก
    async getDataDepartment () {
      this.dataReady = true
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItemFilter?masBranchName=" +
            this.$session.getAll().data.masBranchName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = false
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
          // // console.log('getDataDepartment : ', this.DepartmentItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = false
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
::-webkit-scrollbar {
  width: 0px;
}
::-webkit-scrollbar-track {
  display: none;
}
/deep/ .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;
  border-radius: 0;
  width: 100%;
  & .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
  & .vc-weeks {
    padding: 0;
  }
  & .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
  & .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    &.weekday-1,
    &.weekday-7 {
      background-color: #eff8ff;
    }
    &:not(.on-bottom) {
      border-bottom: var(--day-border);
      &.weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    &:not(.on-right) {
      border-right: var(--day-border);
    }
  }
  & .vc-day-dots {
    margin-bottom: 5px;
  }
}

.v-data-table-header {
  background-color: var(--table-head-bg) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Shift/ImportTimeShiftBranch.vue